import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { SEO } from "@/components/SEO";
import { services } from "@/data/content";

const impacts = [
  "Réduire les risques cyber et gouverner les données avec Purview",
  "Automatiser les tâches à faible valeur ajoutée",
  "Fiabiliser la continuité et la reprise d’activité",
  "Exploiter l’IA avec un cadre sécurisé",
  "Garantir la souveraineté et la localisation des données en France ou en Europe",
  "Équiper vos collaborateurs avec du matériel professionnel adapté et performant",
];

export default function Services() {
  return (
    <div className="px-5 pb-24 pt-36 sm:px-8 lg:pt-44" data-testid="services-page">
      <SEO title="Services" description="Nos services de transformation numérique pour les PME : Microsoft 365, Copilot, Purview, Zero Trust, SOC, IA générative, licences Microsoft, hébergement souverain en France." path="/services" />
      <div className="mx-auto max-w-7xl">
        <SectionHeading
          eyebrow="Services"
          title="Des solutions intégrées, pensées pour la performance et la confiance."
          description="Intellix combine expertise Microsoft, Copilot, Purview, sécurité Cloud, IA générative et automatisation pour construire des environnements numériques accessibles à toutes les PME."
        />
        <div className="mt-16 grid gap-5 md:grid-cols-2 xl:grid-cols-3" data-testid="services-grid">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Reveal key={service.title} delay={index * 0.06}>
                <article className="h-full rounded-3xl border border-border/70 bg-card/60 p-8 transition-transform duration-300 hover:-translate-y-1 hover:border-primary/50" data-testid={`service-card-${index + 1}`}>
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                    <Icon className="h-7 w-7" aria-hidden="true" />
                  </div>
                  <h2 className="mt-8 font-display text-2xl font-semibold tracking-tight">{service.title}</h2>
                  <p className="mt-5 text-sm leading-relaxed text-muted-foreground md:text-base">{service.description}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
        <Reveal className="mt-16">
          <div className="grid gap-8 rounded-[2rem] border border-border/70 bg-card/60 p-8 lg:grid-cols-[0.8fr_1.2fr] lg:p-12" data-testid="services-impact-panel">
            <h2 className="font-display text-3xl font-semibold tracking-tight">Des bénéfices concrets, mesurables et durables.</h2>
            <ul className="grid gap-4 sm:grid-cols-2">
              {impacts.map((impact, index) => (
                <li key={impact} className="rounded-2xl border border-border/70 p-5 text-sm text-muted-foreground" data-testid={`service-impact-${index + 1}`}>
                  {impact}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
